// function to act as a class
function BoldFormatter({ value }) {
    return `<span style="font-weight:500;color:#3c4248">${value}</span>`;
}

export default BoldFormatter;
